import _ from 'lodash'
import moment from 'moment'

const calculateTimeDelay = (start_time, end_time, offset, multiplier) => {
  if (!start_time || !end_time)
    return null
  if (!_.isFinite(multiplier) && !_.isFinite(offset))
    return null
  const time_offset = _.isFinite(offset) ? offset || 0 : 0
  const time_multiplier = _.isFinite(multiplier) ? multiplier : 1
  const time_diff = moment.utc(end_time).diff(moment.utc(start_time), 'minutes')
  return _.max([((time_diff * time_multiplier) + time_offset) * 60 * 1000, 0])
}

export {
  calculateTimeDelay
}
